// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v6.30.2
// source: surveys.proto

/* eslint-disable */
import type { ConversationData } from "./data_import";
import type { Empty } from "./google/protobuf/empty";

export const protobufPackage = "proto";

/** Note: There are also delivery method consts meant to be used in the Go code in src/proto/surveys.proto */
export enum DeliveryMethod {
  EMAIL = "EMAIL",
  HELPDESK = "HELPDESK",
  SNIPPET = "SNIPPET",
}

export interface ConversationSummarizationRequest {
  accountId: string;
  connectionId: string;
  sourceType: string;
  conversation: ConversationData | undefined;
  surveyAnswerId: string;
}

export interface ConversationSummarizationResponse {
  summarization: string;
  suggestions: string[];
}

export interface GetUnsavedSurveyTranslationRequest {
  languageCode: string;
  mailSubject: string;
  introMessage: string;
  thankYouMessage: string;
  question: string;
  reasonList: string[];
  leftRatingScaleLabel: string;
  rightRatingScaleLabel: string;
}

export interface ParseGettextToValuesRequest {
  configurationId: string;
  gettext: string;
}

export interface ParseGettextToValuesResponse {
  values: { [key: string]: string };
}

export interface ParseGettextToValuesResponse_ValuesEntry {
  key: string;
  value: string;
}

export interface ValidateSurveyTriggerConfigurationRequest {
  configurationId: string;
  connectionId: string;
  triggerConditions: SurveyTriggerCondition[];
}

export interface ConflictingSurveyError {
  id: string;
  brand: string;
  deliverySettings: SurveyDeliverySetting[];
}

export interface ValidateSurveyTriggerConfigurationResponse {
  error: ConflictingSurveyError | undefined;
}

export interface SurveyConfigurationId {
  configurationId: string;
}

export interface PreviewSurveyRequest {
  configurationId: string;
  email: string;
  language?: string | undefined;
}

export interface SurveyStatusUpdateRequest {
  configurationId: string;
  status: SurveyStatusUpdateRequest_Status;
}

export enum SurveyStatusUpdateRequest_Status {
  UNKNOWN = "UNKNOWN",
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
}

export interface SurveyConfigurationListLanguage {
  language: string;
  enabled: boolean;
}

export interface SurveyConfigurationListItem {
  id: string;
  status: string;
  createdAt: string | undefined;
  last30DaySurveys: number;
  brand: string;
  languages: SurveyConfigurationListLanguage[];
  surveyFormDomain: string;
}

export interface SurveyConfigurationListResponse {
  surveys: SurveyConfigurationListItem[];
}

export interface PublishedSurveyConfiguration {
  id: string;
  brand: string;
}

export interface PublishedSurveyConfigurationListResponse {
  surveys: PublishedSurveyConfiguration[];
}

export interface SurveyTriggerConfigurationOptionsRequest {
  connectionId: string;
  deliveryMethod: DeliveryMethod;
}

export interface SurveyTriggerConfigurationTagOptionsRequest {
  connectionId: string;
  tag: string;
  limit: number;
}

export interface SurveyTriggerConfigurationFieldOptionsRequest {
  connectionId: string;
  externalFieldId: string;
  field: string;
  limit: number;
}

export interface SurveyTriggerConfigurationOptionsResponse {
  options: SurveyTriggerConfigurationOption[];
  fieldOptions: SurveyTriggerConfigurationFieldOption[];
}

export interface SurveyTriggerConfigurationOption {
  type: SurveyTriggerConfigurationOption_TriggerType;
  allowedMultiple: boolean;
  conditions: SurveyTriggerConfigurationOptionCondition[];
  values: SurveyTriggerConfigurationOptionValue[];
  searchable: boolean;
}

export enum SurveyTriggerConfigurationOption_TriggerType {
  CHANNEL = "CHANNEL",
  STATE = "STATE",
  STATUS = "STATUS",
  TYPE = "TYPE",
  BRAND_DOMAIN = "BRAND_DOMAIN",
  SUPPORT_REP_REPLY_COUNT = "SUPPORT_REP_REPLY_COUNT",
  TAG = "TAG",
  ASSIGNEE = "ASSIGNEE",
  BRAND = "BRAND",
  GROUP = "GROUP",
  EXTERNAL_FIELD = "EXTERNAL_FIELD",
}

export interface SurveyTriggerConfigurationFieldOption {
  externalFieldId: string;
  name: string;
  conditions: SurveyTriggerConfigurationOptionCondition[];
}

export interface SurveyTriggerConfigurationOptionValue {
  key: string;
  value: string;
}

export interface SurveyTriggerConfigurationOptionValues {
  values: SurveyTriggerConfigurationOptionValue[];
  total: number;
}

export interface SurveyTriggerConfigurationOptionCondition {
  condition: SurveyTriggerConfigurationOptionCondition_TypeCondition;
  labelCode: string;
}

export enum SurveyTriggerConfigurationOptionCondition_TypeCondition {
  STRING_LIST_EQUALS = "STRING_LIST_EQUALS",
  STRING_LIST_NOT_EQUALS = "STRING_LIST_NOT_EQUALS",
  INTEGER_LOWER = "INTEGER_LOWER",
  INTEGER_HIGHER = "INTEGER_HIGHER",
  INTEGER_LOWER_EQUALS = "INTEGER_LOWER_EQUALS",
  INTEGER_HIGHER_EQUALS = "INTEGER_HIGHER_EQUALS",
}

export interface SurveyConfiguration {
  id: string;
  draftParentId: string | undefined;
  status: SurveyConfiguration_Status;
  brand: string;
  mailFromName: string;
  mailFromAddress: string;
  mailSubject: string;
  introMessage: string;
  thankYouMessage: string;
  question: string;
  questionScale: SurveyConfiguration_Scale;
  questionScaleDisplay: SurveyConfiguration_ScaleDisplay;
  expiryDays: string | undefined;
  reasonList: string[];
  showReasons: boolean;
  logo: string;
  bgColor: string | undefined;
  btnColor: string | undefined;
  createdAt: string | undefined;
  createdBy: string;
  updatedAt: string | undefined;
  updatedBy: string | undefined;
  deliverySettings: SurveyDeliverySetting[];
  surveyFormDomain: string;
  translations: SurveyTranslation[];
  contentUpdatedAt: string | undefined;
  aiAssistEnabled: boolean;
  questionTypeId: string | undefined;
  leftRatingScaleLabel: string;
  rightRatingScaleLabel: string;
  privacyLink: string;
  termsLink: string;
}

export enum SurveyConfiguration_Status {
  ACTIVE = "ACTIVE",
  PAUSED = "PAUSED",
  DRAFT = "DRAFT",
  DELETED = "DELETED",
}

export enum SurveyConfiguration_Scale {
  SCALE_2 = "SCALE_2",
  SCALE_3 = "SCALE_3",
  SCALE_4 = "SCALE_4",
  SCALE_5 = "SCALE_5",
}

export enum SurveyConfiguration_ScaleDisplay {
  NUMBER = "NUMBER",
  EMOJI = "EMOJI",
}

export interface SurveyTriggerCondition {
  type: SurveyTriggerConfigurationOption_TriggerType;
  condition: SurveyTriggerConfigurationOptionCondition_TypeCondition;
  values: string[];
  externalFieldId?: string | undefined;
}

export interface SurveyDeliverySettingConnection {
  id: string;
  name: string;
  sourceType: string;
  disabled: boolean;
  maskClientData: boolean;
  needsAuth: boolean;
  subdomain: string | undefined;
}

export interface SurveyDeliverySetting {
  connection: SurveyDeliverySettingConnection | undefined;
  enabled: boolean;
  deliveryMethod: DeliveryMethod;
  triggerConditions: SurveyTriggerCondition[];
  emailFollowUpMinutes?: number | undefined;
}

export interface SurveyTranslation {
  language: string;
  values: { [key: string]: string };
  translated: number;
  total: number;
  default: boolean;
  enabled: boolean;
  gettext: string;
  createdAt: string | undefined;
  createdBy: SurveyUser | undefined;
  updatedAt: string | undefined;
  updatedBy: SurveyUser | undefined;
}

export interface SurveyTranslation_ValuesEntry {
  key: string;
  value: string;
}

export interface SurveyUser {
  id: string;
  name: string;
  avatar?: string | undefined;
}

export interface SurveySendMessage {
  accountId: string;
  connectionId: string;
  ticketExternalId: string;
  mailToAddress: string | undefined;
  conf: SurveyConfiguration | undefined;
  variables: SurveyVariables | undefined;
  assigneeExternalID: string | undefined;
  emailDelayMinutes: number | undefined;
  conversation: ConversationData | undefined;
  sourceType: string;
}

export interface SurveyVariables {
  ticketExternalId: string;
  customerName: string | undefined;
  agentName: string | undefined;
  brandName: string;
}

export interface SurveyAnswer {
  id: string;
  surveyId: string;
  paymentId: string;
  paymentTokenId: string;
  externalTicketId: string;
  mailToName: string | undefined;
  mailToAddress: string | undefined;
  score: string | undefined;
  reason: string | undefined;
  comment: string | undefined;
  answeredAt: string | undefined;
  mailFromName: string;
  mailFromAddress: string;
  mailSubject: string;
  introMessage: string;
  thankYouMessage: string;
  question: string;
  questionScale: string;
  questionScaleDisplay: string;
  reasonList: string[];
  showReasons: boolean;
  logo: string;
  bgColor: string | undefined;
  btnColor: string | undefined;
  variables: SurveyVariables | undefined;
  expiresAt: string | undefined;
  createdAt: string | undefined;
  updatedAt: string | undefined;
  brand: string | undefined;
  language: string | undefined;
  answeredLanguage: string | undefined;
  translations: { [key: string]: { [key: string]: any } | undefined };
  feedbackSummary: string | undefined;
  unbranded: boolean;
  commentSuggestions: string[];
  leftRatingScaleLabel: string;
  rightRatingScaleLabel: string;
  privacyLink: string;
  termsLink: string;
  useLiteTemplate: boolean;
}

export interface SurveyAnswer_TranslationsEntry {
  key: string;
  value: { [key: string]: any } | undefined;
}

export interface GetFeedbackReceivedRequest {
  questionTypeId?: string | undefined;
  sort?: string | undefined;
  offset?: string | undefined;
  limit?: string | undefined;
}

export interface GetFeedbackReceivedResponse {
  feedback: GetFeedbackReceivedResponse_Feedback[];
  total: string;
}

export interface GetFeedbackReceivedResponse_Feedback {
  questionTypeId: string;
  responder: string | undefined;
  conversationId: string | undefined;
  connectionId: string | undefined;
  createdAt: string | undefined;
  answerId: string;
  score: string;
  rawData: string;
}

export interface QuestionType {
  id: string;
  name: string;
  isCustom: boolean;
}

export interface QuestionTypesResponse {
  types: QuestionType[];
}

export interface CreateQuestionTypeRequest {
  name: string;
}

export interface EditQuestionTypeRequest {
  id: string;
  name: string;
}

export interface SurveyQuestionAnswer {
  id: string;
  accountId: string;
  connectionId: string;
  questionType: string;
  surveyId: string | undefined;
  surveyAnswerId: string | undefined;
  externalTicketId: string | undefined;
  score: string | undefined;
  externalUserId: string | undefined;
  comment: string | undefined;
  rawData: string | undefined;
  created: string | undefined;
  updated: string | undefined;
  answered: string | undefined;
  entityCreatedAt: string | undefined;
  reason: string | undefined;
}

export interface CreateSurveyConfigurationRequest {
  template: CreateSurveyConfigurationRequest_Template;
}

export enum CreateSurveyConfigurationRequest_Template {
  CSAT = "CSAT",
  CES = "CES",
  CUSTOM = "CUSTOM",
}

export interface GetEmbeddedSnippetRequest {
  configurationId: string;
  connectionId: string;
  language: string;
}

export interface GetEmbeddedSnippetResponse {
  snippet: string;
  snippetPreview: string;
}

export interface GetSurveyLogoUploadUrlRequest {
  mime: string;
}

export interface GetSurveyLogoUploadUrlResponse {
  uploadUrl: string;
  url: string;
  maxSize: number;
}

export interface SurveySummarization {
  GetConversationSummarization(request: ConversationSummarizationRequest): Promise<ConversationSummarizationResponse>;
}

export interface Surveys {
  ListSurveyConfigurations(request: Empty): Promise<SurveyConfigurationListResponse>;
  ListPublishedSurveyConfigurations(request: Empty): Promise<PublishedSurveyConfigurationListResponse>;
  GetSurveyConfiguration(request: SurveyConfigurationId): Promise<SurveyConfiguration>;
  CreateSurveyConfiguration(request: CreateSurveyConfigurationRequest): Promise<SurveyConfigurationId>;
  DuplicateSurveyConfiguration(request: SurveyConfigurationId): Promise<SurveyConfigurationId>;
  EditSurveyConfiguration(request: SurveyConfiguration): Promise<SurveyConfiguration>;
  SendSurveyEmailPreview(request: PreviewSurveyRequest): Promise<Empty>;
  DeleteSurveyConfiguration(request: SurveyConfigurationId): Promise<Empty>;
  UpdateSurveyConfigurationStatus(request: SurveyStatusUpdateRequest): Promise<Empty>;
  GetSurveyTriggerConfigurationValues(
    request: SurveyTriggerConfigurationOptionsRequest,
  ): Promise<SurveyTriggerConfigurationOptionsResponse>;
  GetSurveyTriggerConfigurationTagValues(
    request: SurveyTriggerConfigurationTagOptionsRequest,
  ): Promise<SurveyTriggerConfigurationOptionValues>;
  GetSurveyTriggerConfigurationFieldValues(
    request: SurveyTriggerConfigurationFieldOptionsRequest,
  ): Promise<SurveyTriggerConfigurationOptionValues>;
  ValidateSurveyTriggerConfiguration(
    request: ValidateSurveyTriggerConfigurationRequest,
  ): Promise<ValidateSurveyTriggerConfigurationResponse>;
  ParseGettextToValues(request: ParseGettextToValuesRequest): Promise<ParseGettextToValuesResponse>;
  GetUnsavedSurveyTranslation(request: GetUnsavedSurveyTranslationRequest): Promise<SurveyTranslation>;
  GetFeedbackReceived(request: GetFeedbackReceivedRequest): Promise<GetFeedbackReceivedResponse>;
  GetQuestionTypes(request: Empty): Promise<QuestionTypesResponse>;
  GetSurveyLogoUploadUrl(request: GetSurveyLogoUploadUrlRequest): Promise<GetSurveyLogoUploadUrlResponse>;
  CreateQuestionType(request: CreateQuestionTypeRequest): Promise<QuestionTypesResponse>;
  EditQuestionType(request: EditQuestionTypeRequest): Promise<QuestionTypesResponse>;
  GetEmbeddedSnippet(request: GetEmbeddedSnippetRequest): Promise<GetEmbeddedSnippetResponse>;
}
